import React from "react";
import { GeneralMessage, useGeneralMessage } from "../../../common/APICommon";
import MedicalClearanceModule from "../../components/modules/MedicalClearance/MedicalClearanceModule";
import { AccessRequired } from "../../../common/AccessRequired";

const MedicalClearancePage = ({ user, userAccess, isHideSideMenu }) => {
  const { showMessage, message, isSuccess, showGeneralMessage } = useGeneralMessage();

  // Check if user has either Assignment or Processor access
  const hasAccess = userAccess?.isMedicalClearanceManager || userAccess?.isMedicalClearanceProcessor;

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <div className="MainteInfo shadow-xl bg-white rounded-lg">
          <div className="mainteHeader p-4 border-b">
            <div className='sub-title row text-sm'>
              <span className="text-gray-400">{"Personnel > "}</span>
              <span className="border-b border-black">{"Medical Clearance"}</span>
            </div>
            <h3 className="text-xl font-bold mt-2">Medical Clearance</h3>
          </div>
          {hasAccess ? (
            <MedicalClearanceModule
              user={user}
              userAccess={userAccess}
              showGeneralMessage={showGeneralMessage}
            />
          ) : (
            <div className="p-10">
              <AccessRequired
                userAccess={userAccess}
                moduleName={"Medical Clearance Access"}
                pathName={"/medicalClearanceAccess"}
              />
            </div>
          )}
        </div>
      </div>
      <GeneralMessage form={showMessage} message={message} isSuccess={isSuccess} />
    </div>
  );
};

export default MedicalClearancePage;